import ModalsContainer from './ModalsContainer'

export default ModalsContainer



// WEBPACK FOOTER //
// ./src/containers/Modals/index.js